import * as R from 'ramda';


export default function BulkDeleteAssetsDialogController(
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  alerts,
  loaderService,
  assetDataService,
  bulkDeleteAssetsConfirmDialog
) {
  const vm = this;

  vm.deleteIsSelected = false;
  vm.hasData = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkDeleteDialogClick = _handleBulkDeleteDialogClick;
  vm.handleSelectAll = _handleSelectAll;

  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
    $scope.$on('selectBulkAssetChange', () => {
      _handleSelectAssetChange();
    });
  }

  function _handleBulkDeleteDialogClick($event) {
    const _ids = [];

    R.forEach((asset) => {
      if (asset.isBulkDelete) {
        _ids.push(asset.customerAssetId);
      }
    }, vm.assetType.customerAssets);

    ssDialogService.dialogs.assetAdmin.bulkDeleteAssetsConfirmDialog = ssDialogService.alert(
      bulkDeleteAssetsConfirmDialog.getOptions($event, {
        assets: _ids,
        updateCallBack: _completeBulkDelete,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.assetAdmin.bulkDeleteAssetsConfirmDialog);
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.assetAdmin.bulkDeleteAssetsDialog);
  }

  function _handleSelectAll() {
    R.forEach((asset) => {
      asset.isBulkDelete = vm.selectAll;
    }, vm.assetType.customerAssets);
        
    vm.deleteIsSelected = vm.selectAll;
  }

  function _handleSelectAssetChange() {
    const selectedIds = [];
    
    R.forEach((item) => {
      if (item.isBulkDelete === true) {
        selectedIds.push(item.customerAssetId);
      }
    }, vm.assetType.customerAssets);

    vm.deleteIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.assetType.customerAssets.length;
  }

  /** ************************************************
   * Private Functions
   */
  function _completeBulkDelete() {
    $rootScope.$broadcast('refreshAssets', { assetType: vm.assetType });
    _handleCloseDialog();
  }
}

BulkDeleteAssetsDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'alerts',
  'loaderService',
  'assetDataService',
  'bulkDeleteAssetsConfirmDialog',
];
